import { Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
  ],
})
export class SnackbarComponent implements OnInit {
  snackBarRef = inject<MatSnackBarRef<SnackbarComponent>>(MatSnackBarRef);
  data = inject(MAT_SNACK_BAR_DATA);
  private clipboard = inject(Clipboard);

  icon: string;
  copied: boolean;

  
 

  

  ngOnInit() {
    this.icon = this.getIcon();
  }

  getIcon() {
    switch (this.data.snackbarType) {
      case 'Success':
        return 'check_circle';
      case 'Failure':
        return 'error';
      default:
        return null;
    }
  }

  isStringMessage(msg: string): boolean {
    return typeof msg === 'string';
  }

  copyToClipboard(event: MouseEvent) {
    event.stopPropagation();
    let textToCopy = this.data.snackbarType + ' - ';
    if (this.data.title) {
      textToCopy += 'Title: ' + this.data.title + ' Message: ';
    }
    textToCopy += this.data.message;
    if (this.clipboard.copy(textToCopy)) {
      this.copied = true;
    }
  }
}
